import { render, staticRenderFns } from "./AttachmentsTable.vue?vue&type=template&id=ff44a842&"
import script from "./AttachmentsTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsTable.vue?vue&type=style&index=0&id=ff44a842&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports